import { render, staticRenderFns } from "./Micropoint.vue?vue&type=template&id=b3004f02&scoped=true"
import script from "./Micropoint.vue?vue&type=script&lang=js"
export * from "./Micropoint.vue?vue&type=script&lang=js"
import style0 from "./Micropoint.vue?vue&type=style&index=0&id=b3004f02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3004f02",
  null
  
)

export default component.exports